import { Box } from '@mui/material';
import capitalizeFirstLetter from './capitalizedFunc';

export const getStatusColour = (status, value) => {
    if (status === 'FAILED_TO_ATTEND_CONSULTATION') {
        if (value === 'background') {
            return 'rgba(255, 72, 66, 0.16)';
        }
        if (value === 'color') {
            return '#B72136';
        }
    }
    if (status === 'NEW') {
        if (value === 'background') {
            return 'rgba(24, 144, 255, 0.16)';
        }
        if (value === 'color') {
            return '#0C53B7';
        }
    }
    if (status === 'CONSULTATION_BOOKED' || status === 'CONSULTATION_ATTENDED') {
        if (value === 'background') {
            return 'rgba(255, 193, 7, 0.16)';
        }
        if (value === 'color') {
            return '#B78103';
        }
    }
    if (status === 'CREDIT_CHECK') {
        if (value === 'background') {
            return 'rgba(255, 72, 66, 0.16)';
        }
        if (value === 'color') {
            return '#B72136';
        }
    }
    if (status === 'CLOSED' || status === 'TREATMENT_FINISHED') {
        if (value === 'background') {
            return 'rgba(145, 158, 171, 0.16)';
        }
        if (value === 'color') {
            return '#637381';
        }
    }
    if (status === 'TREATMENT_BOOKED') {
        if (value === 'background') {
            return 'rgba(84, 214, 44, 0.16)';
        }
        if (value === 'color') {
            return '#229A16';
        }
    }
    if (status === 'TREATMENT_STARTED') {
        if (value === 'background') {
            return 'rgba(24, 144, 255, 0.16)';
        }
        if (value === 'color') {
            return '#0C53B7';
        }
    }
    return null;
};

export const isDentallySyncTask = (note) => /dentally/i.test(note || '');

export const getMessage = (value, firstName, lastName, rawTreatment, group, method, note) => {
    if (isDentallySyncTask(note)) {
        return (
            <Box sx={{ fontSize: '12px', lineHeight: 'inherit' }}><b>Sync with Dentally</b></Box>
        );
    }
    const fName = capitalizeFirstLetter(firstName || '');
    const lName = capitalizeFirstLetter(lastName || '');
    const safeName = `${fName} ${lName}`.trim() || 'Patient';
    const treatment = rawTreatment || "the treatment she needs"
    const content = (() => {
        if (method === 'PAYMENT') {
            return `<b>Dentally payment due</b> — check payment status for <b>${safeName}</b>`;
        }
        if (group === 'TODO') {
            return `${capitalizeFirstLetter(method === 'OTHER' ? 'Discuss with' : method)} <b>${safeName}</b> about <b>${treatment}</b>`;
        }
        switch (value) {
            case 'NEW':
                return `${capitalizeFirstLetter(method === 'OTHER' ? 'Discuss with' : method)} <b>${safeName}</b> about <b>${treatment}</b>`;
            case 'CONSULTATION_BOOKED':
                return `<b>Record</b> if <b>${safeName} attended</b> their <b>${treatment} consultation</b>`;
            case 'CONSULTATION_ATTENDED':
                return `<b>${safeName}</b> is <b>considering ${treatment}. Follow up</b> to discuss.`;
            case 'FAILED_TO_ATTEND_CONSULTATION':
                return `<b>${safeName} failed to attend</b> their <b>${treatment}</b> consultation. <b>Follow up.</b>`;
            case 'CLOSED':
                return `<b>${safeName} completed</b> their <b>${treatment}</b> treatment.`;
            default:
                return `${capitalizeFirstLetter(method === 'OTHER' ? 'Discuss with' : method)} <b>${safeName}</b> about <b>${treatment}</b>`;
        }
    })();

    return (
        <Box sx={{ fontSize: '12px', lineHeight: 'inherit' }} dangerouslySetInnerHTML={{ __html: content }} />
    );
};